import axios from "axios";
import { ApiRoutesE, getApiUrl } from "../../../helpers/routes";

type getCampaignAccessibleT = (id: string) => Promise<{ accessible: boolean }>;
export const getCampaignAccessible: getCampaignAccessibleT = async (id) =>
  axios
    .get(getApiUrl(ApiRoutesE.CAMPAIGN_ACCESSIBLE, id))
    .then((res) => res.data);
